import { IMG_NOT_AVAILABLE_URL } from "@/types/constants/common";
import { useState } from "react";

interface Props {
  imageURL: string | null | undefined;
  style?: React.CSSProperties;
}

const Thumbnail = ({ imageURL, style }: Props) => {
  const [isError, setIsError] = useState(false);

  return (
    <img
      src={imageURL && !isError ? imageURL + "?w=110&h=90" : IMG_NOT_AVAILABLE_URL + "?w=110&h=90"}
      onError={() => {
        setIsError(true);
      }}
      style={{
        display: "inline-block",
        width: "90px",
        minWidth: "90px",
        height: "55px",
        objectFit: "cover",
        borderRadius: "var(--ttand-radius-sm)",
        border: "1px solid",
        borderColor: "var(--joy-palette-neutral-300, #CDD7E1)",
        ...style,
      }}
    />
  );
};
export default Thumbnail;
